import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import type { Dispatch } from "redux";

import type {
  DispatchToProps,
} from "./types/Login.types";
import Login from "../../components/Login";
import { setAuthDataSaga } from "../../actions/auth";

const mapDispatchToProps: (arg0: Dispatch<any>) => DispatchToProps = dispatch => ({
  ...bindActionCreators({
    onLogin: setAuthDataSaga,
  }, dispatch),
});

export default connect(null, mapDispatchToProps)(Login);
